<template>
    <div v-if="banner && banner.is_enabled" class="header header--promo text_11">
        <div class="flex-c">
            <span v-html="banner.text"></span>
            <countdown v-if="banner.timer_end_at" :end-time="banner.timer_end_at" :auto-start="true">
                <template #process="{ timeObj }">
                    <span v-if="timeObj.ceil.d - 1 > 0"
                        >{{ timeObj.d }}<span>{{ $t("count_down_day") }}</span>
                    </span>
                    <span v-if="timeObj.ceil.h - 1 > 0"
                        >{{ timeObj.h }}<span>{{ $t("count_down_hour") }}</span>
                    </span>
                    <span v-if="timeObj.ceil.m - 1 > 0"
                        >{{ timeObj.m }}<span>{{ $t("count_down_minute") }}</span>
                    </span>
                    <span v-if="timeObj.ceil.s - 1 > 0"
                        >{{ timeObj.s }}<span>{{ $t("count_down_second") }}</span>
                    </span>
                </template>
            </countdown>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "HeaderPromo",
    computed: {
        ...mapGetters("globalvars", ["getBanner"]),
        isEnabled() {
            return this.banner && this.banner.is_enabled;
        },
        banner() {
            return this.getBanner.promo_header;
        },
    },
    head() {
        return {
            htmlAttrs: {
                class: this.isEnabled ? "has-promo-header" : "",
            },
        };
    },
};
</script>
<style lang="less" scoped>
.header.header--promo {
    padding: 0;
    background: #000;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    color: #fff;
    .flex-c {
        gap: 16px;
        @media @sm {
            flex-direction: column;
            gap: 2px;
        }
    }
    svg {
        margin: 0 16px;
    }
    @media @sm {
        top: 0 !important;
    }
}
</style>
